export default "__VITE_ASSET__VvCjFwmn__"